import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthGroup } from 'app/core/interfaces/authorization.types';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { HttpClient } from '@angular/common/http';
import { CurrentUser } from 'app/core/interfaces/currentUser';
import { environment } from 'app/environments/environment';
import { EncrDecrService } from 'app/core/http/services/encr-decr.service';
import { LayoutService } from 'app/core/http/services/layout.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<CurrentUser>;
  public currentUser: Observable<CurrentUser>;

  constructor(
    private readonly jwtHelper: JwtHelperService,
    private readonly http: HttpClient,
    private readonly cript: EncrDecrService,
    private readonly layout: LayoutService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.currentUserSubject = new BehaviorSubject<CurrentUser>(
      this.getCurrentUser()
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): CurrentUser {
    return this.currentUserSubject.value;
  }

  public getCurrentUser() {
    if (!localStorage.getItem('currentUser')) {
      return;
    }

    return JSON.parse(
      this.cript.decrypt(
        environment.secret,
        localStorage.getItem('currentUser')
      )
    );
  }

  public clearLogin() {
    if (localStorage.getItem('token') || localStorage.getItem('currentUser')) {
      localStorage.clear();
      this.router.navigate(['login']);
    }
  }


  public getFromLocalStorage(item: string) {
    const list: any = localStorage.getItem(item);
    if (list) {
      return JSON.parse(list);
    }
    return [];
  }

  public addLocalStorage(item: string, content: any) {
    let list: any = localStorage.getItem(item);
    if (list) {
      list = JSON.parse(list);
      list.push(content);
      localStorage.setItem(item, JSON.stringify(list));
    }
  }

  public updateLocalStorageById(item: string, id: number, content: any) {
    let list: any = localStorage.getItem(item);
    if (list) {
      list = JSON.parse(list);
      list.map((item: any, index: number) =>
        item.id == id ? (list[index] = content) : item
      );
      localStorage.setItem(item, JSON.stringify(list));
    }
  }

  public removeFromLocaStorageMock(item: string, id: number) {
    let itens: any = this.getFromLocalStorage(item);
    const index = itens.findIndex((item: any) => item['id'] === id);
    itens =
      index >= 0
        ? [...itens.slice(0, index), ...itens.slice(index + 1)]
        : itens;
    localStorage.setItem(item, JSON.stringify(itens));
  }

  public getAccessToken() {
    return localStorage.getItem('userTokenId')
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    const token_id = localStorage.getItem('token_id');
   
    if (token) return true;

    return false;

   
  }

  public setUser(
    actorUser: any,
    type: 'organization' | 'secretary' | 'patient' | 'practitioner',
    token: any,
    sub: any
  ) {
    switch (type) {
      case 'organization':
        actorUser.id = actorUser.organization_id;
        break;
      case 'secretary':
        actorUser.id = actorUser.secretaries_id;
        break;
      case 'practitioner':
        actorUser.id = actorUser.practitioner_id;
        break;
      default:
        actorUser.id = actorUser.patient_id;
        break;
    }

    let user: CurrentUser = {
      user: actorUser,
      access_token: token,
      token_type: '',
      expires_in: '',
      type: type,
    };
    localStorage.setItem(
      'currentUser',
      this.cript.encrypt(environment.secret, JSON.stringify(user))
    );
    localStorage.setItem('token', token);
    localStorage.setItem('token_id', sub);
    localStorage.setItem('userType', type);
  }

  public updateCurrentUser(currentUser: CurrentUser) {
    localStorage.setItem(
      'currentUser',
      this.cript.encrypt(environment.secret, JSON.stringify(currentUser))
    );
  }

  public hasPermission(authGroup: AuthGroup | null) {
    return this.currentUserValue.type === authGroup;
  }

  public isAdmin() {
    if (!this.currentUserValue) {
      return false;
    }
    return this.currentUserValue.type == 'organization';
  }

  logout() {
    localStorage.clear()

    this.currentUserSubject.next({} as CurrentUser);

    this.redirectToLogin()
  }

  logoutByInactivate(){

    localStorage.clear()

    this.currentUserSubject.next({} as CurrentUser);

    this.redirectToLogin()

    this.snackBar.open("Sua sessão foi finalizada por inatividade", '', {
      duration: 5000,
      panelClass: 'snack-warning',
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });

   
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 404: {
        return `Not Found: ${error.message}`;
      }
      case 403: {
        return `Access Denied: ${error.message}`;
      }
      case 500: {
        return `Internal Server Error: ${error.message}`;
      }
      default: {
        return `Unknown Server Error: ${error.message}`;
      }
    }
  }

  public redirectToLogin(){

    return this.router.navigate(['/login'])


  }
}
